import React from "react";
import {FaStar} from "react-icons/fa";


function MySounds() {

    return (
        <div className="MySounds">
            <h1><span className="align-text-top"><FaStar/></span> My Sounds</h1>
            <div className="alert alert-warning mt-3">
                <h4>This page is under construction!</h4>
                <p>This will show user uploaded sounds.</p>
            </div>
        </div>
    );

}

export default MySounds;